import { useEffect } from "react"
import ViewApplication from "pages/BaseApplication/ViewApplication"
import BaselDetails from "./BaselDetails"
import RotterdamDetails from "./RotterdamDetails"

const RotterdamConvention = props => {
  useEffect(() => {}, [])

  return (
    <>
      <ViewApplication
        attachments={props.appDetails.application_attachments}
        appDetails={props.appDetails}
        appDetailsComponent={<RotterdamDetails appDetails={props.appDetails} />}
      />
    </>
  )
}

export default RotterdamConvention
